import styled from "styled-components";
import {UnderTopBarFloater} from "../../../../AppStyle";

export const RideAcceptedTopContainer = styled.div`
    ${UnderTopBarFloater};
    max-height: 52.2px;
    font-weight: 400;
    color: #555555;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
`;

export const RideAcceptedTopImg = styled.img`
    margin-left: 3px;
    margin-right: 3px;
`;

const rideAcceptedTopLabelLineHeight = 19;

export const RideAcceptedTopLabel = styled.label`
    line-height: ${rideAcceptedTopLabelLineHeight}px;
    font-size: 15px;
    max-height: ${rideAcceptedTopLabelLineHeight * 2};
    margin-top: ${rideAcceptedTopLabelLineHeight * 2};
    margin-bottom: ${rideAcceptedTopLabelLineHeight * 3};
    overflow: hidden;
    margin-left: 3px;
    margin-right: 3px;
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAcceptedTop/RideAcceptedTopStyle.js